/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import AddIcon from 'Assets/images/commons/iconAdd.svg';
import IconUploadErr from 'Assets/images/commons/iconUploadErr.svg';
import PreviewIcon from 'Assets/images/commons/previewIcon.svg';
import RemoveIcon from 'Assets/images/commons/removeIcon.svg';
import RetryIcon from 'Assets/images/commons/retryIcon.svg';
import usePreviewFile from 'Hooks/files/usePreviewFile';
import useAuth from 'Hooks/useAuth';
import FileIconView from 'Modules/AttachmentsView/FileIcon';
import { bool, func, shape, string } from 'prop-types';
import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { Image, Loader, Popup } from 'semantic-ui-react';

import styles from './FileUploadField.less';

export const TYPE_FILE = 1;
export const TYPE_APPOINTMENT = 2;

const ERROR_STATUS = 'error';
const LOADING_STATUS = 'loading';
const SUCCESS_STATUS = 'success';

const FileInputItem = props => {
  const {
    onFileSelected,
    handleFileRemove,
    fileUpload,
    value,
    isPublic,
    allowFileType,
    multiple,
    disabled,
  } = props;

  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const { handlePreview } = usePreviewFile();
  const { token } = useAuth();

  const handleSelectedFile = async evt => {
    try {
      const { files } = evt.target;
      Array.from(files).forEach(async file => {
        const formData = new FormData();
        formData.append('is_public', isPublic);
        formData.append('file', file, `${Date.now()}-${file.name}`);
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend = () => {
          const img = {
            id: Date.now(),
            originalPath: reader.result,
            thumbPath: reader.result,
            mime: file.type,
            uploadStatus: LOADING_STATUS,
            formData,
          };
          onFileSelected(undefined, img);
          fileUpload(formData)
            .then(res => {
              onFileSelected(img, { ...res, uploadStatus: SUCCESS_STATUS });
            })
            .catch(err => {
              toast(err?.message ?? 'Upload file error', {
                icon: '❌',
                position: 'top-right',
              });
              img.uploadStatus = ERROR_STATUS;
              onFileSelected(img, img);
            });
        };
      });
    } catch (error) {
      // console.log('error11', error);
    } finally {
      setLoading(false);
      inputRef.current.value = null;
    }
  };

  const handleRetryUpload = data => {
    const imgObj = {
      ...data,
      uploadStatus: LOADING_STATUS,
    };
    onFileSelected(data, imgObj);
    fileUpload(data.formData)
      .then(res => {
        onFileSelected(data, { ...res, uploadStatus: SUCCESS_STATUS });
      })
      .catch(err => {
        toast(err?.message ?? 'Upload file error', {
          icon: '❌',
          position: 'top-right',
        });
        const newData = { ...data };
        newData.uploadStatus = 'error';
        onFileSelected(data, newData);
      });
  };

  const triggerInputFile = () => {
    if (!loading) inputRef.current.click();
  };

  const handleRemove = e => {
    e.stopPropagation();
    handleFileRemove(value);
  };

  const hasValue = value && value.id;
  const isError = value?.uploadStatus === ERROR_STATUS;
  const isLoading = value?.uploadStatus === LOADING_STATUS;

  return (
    <div
      className={styles.buttonContainer}
      style={{
        borderStyle: !hasValue || isLoading ? 'dashed' : 'solid',
        borderColor: isLoading ? '#0984E3' : isError ? 'red' : '#dedede',
      }}
      onClick={hasValue ? undefined : triggerInputFile}>
      {isLoading && <Loader active size="small" />}
      {isError ? (
        <Popup
          position="top center"
          trigger={
            <div>
              <img src={IconUploadErr} className={styles.img} title="Upload error" alt="" />
              <div className={styles.actions}>
                <div className={styles.remove} onClick={() => handleRetryUpload(value)}>
                  <img src={RetryIcon} alt="retry" />
                </div>
                {!disabled && (
                  <div className={styles.remove} onClick={handleRemove}>
                    <img src={RemoveIcon} alt="Remove" />
                  </div>
                )}
              </div>
            </div>
          }
          content="Upload failed"
          inverted
        />
      ) : hasValue ? (
        <>
          <FileIconView file={value} />
          <div className={styles.actions}>
            <div className={styles.preview} onClick={() => handlePreview(value, token)}>
              <img src={PreviewIcon} alt="Preview" />
            </div>
            {!disabled && (
              <div className={styles.remove} onClick={handleRemove}>
                <img src={RemoveIcon} alt="Remove" />
              </div>
            )}
          </div>
        </>
      ) : (
        <Image src={AddIcon} className={styles.img} alt="add image" />
      )}
      <input
        type="file"
        multiple={multiple}
        onChange={handleSelectedFile}
        style={{ display: 'none' }}
        ref={inputRef}
        accept={allowFileType}
        disabled={disabled}
      />
    </div>
  );
};

FileInputItem.propTypes = {
  value: shape({}),
  handleFileRemove: func,
  onFileSelected: func,
  fileUpload: func,
  isPublic: bool.isRequired,
  multiple: bool.isRequired,
  allowFileType: string.isRequired,
  disabled: bool.isRequired,
};

FileInputItem.defaultProps = {
  value: null,
  handleFileRemove: () => {},
  onFileSelected: () => {},
  fileUpload: () => {},
};

export default FileInputItem;
